export default class Events {
    static DOMContentLoadedEvents = () => {
        copyToClipboardInit();
        initializeBackendCloseButton();
        openSearchBodyIfNeeded();
        initializeCloseAppBrowserButton();
    };

    static KnowledgeBaseLoadedEvents = () => {
        copyToClipboardInit();
        initializeRedirectToKnowledgeBaseFromBackendCloseButton();
    };

    static loadEvents = () => {
        setTimeout(() => {
            addChangeHandlerToGoogleTranslateSelectBox();
            addClickHandlerToLanguageSwitchToggle();
        }, 1000);
    };

    static zdsNavigationBodyOpenedEvents = (event) => {
        focusOnLoginOnNavigationBodyOpenClick(event);
    };
}

// Set focus to first input field when menu is opened
const focusOnLoginOnNavigationBodyOpenClick = (event) => {
    if (event.detail.identifier === 'login-plugin') {
        document.querySelector('.login-plugin-container input').focus();
    }
};

function initializeBackendCloseButton() {
    const closeButton = document.getElementById('close-backend-layout');

    if (!closeButton || closeButton.getAttribute('initialized') === 'true') {
        return;
    }

    if (document.referrer) {
        const referrerPath = new URL(document.referrer).pathname;

        if (referrerPath !== getFormPath()) {
            sessionStorage.setItem(getSessionKey(), referrerPath);
        }
    }

    if (!closeButton.getAttribute('link')) {
        closeButton.addEventListener('zdsClick', () => {
            if (closeButton.getAttribute('prevent-link') === 'true') {
                return;
            }

            const referrer = sessionStorage.getItem(getSessionKey());

            window.location.href = sessionStorage.getItem(referrer) || referrer || '/';
        });
    }

    function getSessionKey() {
        return 'referrer' + getFormPath();
    }

    function getFormPath() {
        return document.location.pathname;
    }

    closeButton.setAttribute('initialized', 'true');
}

// Copy to clipboard functionalty
function copyToClipboardInit() {
    const copyToClipboardElements = document.querySelectorAll('.copy-to-clipboard:not(.activated)');

    copyToClipboardElements.forEach((element) => {
        element.classList.add('activated');
        const copyIcon = document.createElement('i');
        copyIcon.classList.add('copy-to-clipboard-icon', 'fa-solid', 'fa-copy');
        element.appendChild(copyIcon);

        element.addEventListener('click', () => {
            navigator.clipboard.writeText(element.innerText);
        });
    });
}

const initializeRedirectToKnowledgeBaseFromBackendCloseButton = () => {
    const knowledgeBaseButtons = document.querySelectorAll('.knowledgeBase-content zds-button');

    knowledgeBaseButtons.forEach((button) => {
        button.addEventListener('zdsClick', () => {
            sessionStorage.setItem(document.location.pathname, document.location.pathname + document.location.hash);
        });
    });
};

function addChangeHandlerToGoogleTranslateSelectBox() {
    const element = document.querySelector('#\\:0\\.targetLanguage > select');
    if (element) {
        element.addEventListener('change', () => {
            document.getElementById('language-switch-modal').getElementsByTagName('zds-modal')[0].hide();
        });
    }
}

function addClickHandlerToLanguageSwitchToggle() {
    // Open language switch modal when clicking on current language in top navigation
    Array.from(document.getElementsByClassName('language-switch-toggle')).forEach((element) => {
        const languageSwitchModal = document
            .getElementById('language-switch-modal')
            .getElementsByTagName('zds-modal')[0];
        element.addEventListener('zdsClick', () => {
            languageSwitchModal.show();
        });

        element.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                languageSwitchModal.show();
            }
        });

        languageSwitchModal.tabIndex = 0;
    });
}

function openSearchBodyIfNeeded() {
    // If get parameter search=searchquery is set, open the search body from the navigation
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('search');
    if (searchQuery) {
        const navigation = document.getElementById('main-navigation');
        navigation?.openBody('search-body');
    }
}

function initializeCloseAppBrowserButton() {
    document.querySelectorAll('zds-button.close-app-browser-button').forEach((closeButton) => {
        closeButton.addEventListener('zdsClick', () => {
            window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ message: 'closeInAppBrowser' }));
        });
    });
}
